import flatpickr from 'flatpickr'
import { Polish } from 'flatpickr/dist/l10n/pl.js'
import { German } from 'flatpickr/dist/l10n/de.js'
import dayjs from 'dayjs'
import { setBseWidgetDate, today, secondDay } from './set-bse-widget-date'

const locales = {
  pl: Polish,
  de: German,
  en: 'en',
}
const currentLang = document.documentElement.lang.substring(0, 2)

let selectedDates = [today, secondDay]
setBseWidgetDate()
const bseWidgetFrame = document.querySelector('#bse-widget-frame')
const callWidgetBtns = document.querySelectorAll('.call-bse-widget')
const bseIframe = document.createElement('div')
bseIframe.className = 'bse-widget-frame-content'
bseWidgetFrame.appendChild(bseIframe)
const closeWidgetArr = document.querySelectorAll(
  '.bse-close, #bse-widget-frame'
)
const bseArrows = document.querySelectorAll('.bse-arrow')
const urlBase = 'https://booking.hotres.pl/v4_step1'
const oid = '5266'

// call widget function
const callWidget = () => {
  let personsCount = 2

  if (document.querySelector('.persons-count')) {
    const personsCountElement = document.querySelector('.persons-count')
    personsCount = personsCountElement.value
      ? Number(personsCountElement.value)
      : 2
  }

  const url = new URL(urlBase)
  url.searchParams.set('oid', oid)
  url.searchParams.set('arrival', selectedDates[0].format('YYYY-MM-DD'))
  url.searchParams.set('departure', selectedDates[1].format('YYYY-MM-DD'))
  url.searchParams.set('adults', personsCount)
  url.searchParams.set('clear', 1)
  url.searchParams.set('lang', currentLang)

  window.open(url)
}

// call widget listeners
callWidgetBtns.forEach((button) => {
  button.addEventListener('click', () => {
    callWidget()
  })
})

// close widget
closeWidgetArr.forEach((element, index) => {
  element.addEventListener('click', function (e) {
    bseWidgetFrame.classList.add('hide')
    document.querySelector('body').classList.remove('block')
    setTimeout(function () {
      bseWidgetFrame.classList.remove('!block')
      bseWidgetFrame.classList.remove('hide')
    }, 300)
  })
})

// create new flatpicker instance - header bse widget
document.addEventListener('DOMContentLoaded', () => {
  const flatpickrCallers = document.querySelectorAll('.flatpickr-caller')
  if (flatpickrCallers.length) {
    const engineWidgetWrapper = document.querySelector('.engine-widget')
    const fp = flatpickr('#flatpickr-input', {
      locale: locales[currentLang],
      dateFormat: 'd/m/Y',
      positionElement: engineWidgetWrapper,
      position: 'above center',
      mode: 'range',
      showMonths: 2,
      minDate: 'today',
      minRange: 2,
      onChange: (dates) => {
        if (dates.length > 1) {
          selectedDates = [dayjs(dates[0]), dayjs(dates[1])]
          callWidget()
          setBseWidgetDate(...selectedDates)
        }
      },
      onClose: () => {
        bseArrows.forEach((arrow) => {
          arrow.classList.remove('-rotate-180')
        })
      },
    })

    flatpickrCallers.forEach((caller) => {
      caller.addEventListener('click', () => {
        fp.open()
        bseArrows.forEach((arrow) => {
          arrow.classList.add('-rotate-180')
        })
      })
    })
  }
})

let firstDate = today
let secondDate = secondDay
// create new flatpicker - aside bse widget
document.addEventListener('DOMContentLoaded', () => {
  const flatpickrCallers = document.querySelectorAll('.flatpickr-single-date')
  if (flatpickrCallers.length) {
    const asideWidgetWrapper = document.querySelector('.engine-widget')

    const fpFirst = flatpickr('#flatpickr-input-first-date', {
      locale: locales[currentLang],
      dateFormat: 'd/m/Y',
      positionElement: document.querySelector('#dateRangeStart'),
      position: 'above center',
      mode: 'single',
      showMonths: 1,
      minDate: 'today',
      disableMobile: true,
      onChange: (dates) => {
        if (dates.length > 0) {
          firstDate = dayjs(dates[0])
          selectedDates[0] = firstDate
          setBseWidgetDate(...selectedDates)
          // Update minDate for fpSecond
          if (fpSecond) {
            fpSecond.set('minDate', firstDate.add(1, 'day').toDate())
            if (firstDate > secondDate) {
              const newSecondDate = firstDate.add(1, 'day')
              fpSecond.setDate(newSecondDate.toDate())
              secondDate = newSecondDate
              selectedDates[1] = secondDate
              setBseWidgetDate(...selectedDates)
            }
          }
        }
      },
    })

    flatpickrCallers[0].addEventListener('click', () => {
      fpFirst.open()
    })

    const fpSecond = flatpickr('#flatpickr-input-second-date', {
      locale: locales[currentLang],
      dateFormat: 'd/m/Y',
      positionElement: document.querySelector('#dateRangeEnd'),
      position: 'above center',
      mode: 'single',
      showMonths: 1,
      minDate: dayjs(firstDate).add(1, 'day').toDate(),
      disableMobile: true, // Initial minDate
      onChange: (dates) => {
        if (dates.length > 0) {
          secondDate = dayjs(dates[0])
          selectedDates[1] = secondDate
          setBseWidgetDate(...selectedDates)
          callWidget() // Call widget after second date change
        }
      },
    })

    flatpickrCallers[1].addEventListener('click', () => {
      fpSecond.open()
    })
  }
})

// ---
// bse widget aside

const bseWidgetAside = document.querySelector('.bse-widget-aside')
if (bseWidgetAside) {
  const bseWidgetAsideBtn = document.querySelector('.bse-widget-aside-btn')
  bseWidgetAsideBtn.addEventListener('click', () => {
    bseWidgetAside.classList.toggle('open')
  })
}

// ---
// single flatpickr for reservation form
if (document.querySelector('.flatpickr-single')) {
  const element = document.querySelector('.flatpickr-single')

  flatpickr.localize(Polish)
  flatpickr(element, {
    dateFormat: 'd.m.Y',
    positionElement: element,
    showMonths: 1,
    minDate: 'today',
  })
}
